/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState} from 'react';
import qs from "qs";
import styles from './ModooCarList.module.scss';
import PageTitle from "../../components/common/PageTitle/PageTitle";
import ModooCarListFilters from "./ModooCarListFilters/ModooCarListFilters";
import {ModooCarListDataInterface, ModooCarListFilterInterface, modooEmptyCarListFilter} from "./ModooCarList.interface";
import ModooCarListTable from "./ModooCarListTable/ModooCarListTable";
import apiClient from "../../api/apiClient";

const ModooCarList = () => {
	const [data, setData] = useState<ModooCarListDataInterface[]>([]);
	const [filter, setFilter] = useState<ModooCarListFilterInterface>(modooEmptyCarListFilter);

	const onSearch = async () => {
		const query = qs.stringify(filter);
		const res = await apiClient.get(`/api/admin/business/user/car/list?${query}`)
		setData(res.data);
	};

	const onSelectLocation = (locations: string[]) => {
		setFilter((prev) => ({...prev, locations }));
	};

	const onSelectCarType = (carTypes: string[]) => {
		setFilter((prev) => ({...prev, carTypes }));
	};

	const onClear = () => {
		setFilter(modooEmptyCarListFilter);
		setData([]);
	};

	return (
		<div className={styles.wrap}>
			{/* 타이틀 */}
			<PageTitle title="모두의배차방 차량 조회"/>

			<div className={styles.filterWrap}>
				<ModooCarListFilters
					locations={filter.locations}
					carTypes={filter.carTypes}
					onSelectLocation={onSelectLocation}
					onSelectCarType={onSelectCarType}
					onSearch={onSearch}
					onClear={onClear}
				/>
			</div>

			<div className={styles.tableWrap}>
				<ModooCarListTable data={data} />
			</div>
		</div>
	);
};

export default ModooCarList;
